const ADMIN_TOKEN_KEY = 'admin_token';
const ADMIN_SESSION_NOTICE_KEY = 'admin_session_notice';

export const ADMIN_SESSION_EXPIRED_EVENT = 'webouse:admin-session-expired';
export const ADMIN_SESSION_EXPIRED_MESSAGE =
  'Oturum süreniz doldu, tekrar giriş yapın.';

export const getAdminToken = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  return sessionStorage.getItem(ADMIN_TOKEN_KEY);
};

export const setAdminToken = (token) => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
};

export const clearAdminToken = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
};

export const setAdminSessionNotice = (message = ADMIN_SESSION_EXPIRED_MESSAGE) => {
  sessionStorage.setItem(ADMIN_SESSION_NOTICE_KEY, message);
};

export const consumeAdminSessionNotice = () => {
  const message = sessionStorage.getItem(ADMIN_SESSION_NOTICE_KEY);
  sessionStorage.removeItem(ADMIN_SESSION_NOTICE_KEY);
  return message;
};

export const redirectToAdminLogin = () => {
  window.location.assign('/admin?reason=session_expired');
};
